import React, { useEffect, useState } from "react";
import { IoSearchOutline, IoWarning } from "react-icons/io5";
import { LuBadgeCheck } from "react-icons/lu";
import '../../css/items.scss';
import { serverInstance } from "../../service/axios";
import Dimmer from "../shared/Dimmer";
import './doctors.scss';

const Doctors = ({ data }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [registeredDoctors, setRegisteredDoctors] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [alumniData, setAlumniData] = useState([]);
  const [matchingAlumniData, setMatchingAlumniData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    serverInstance.get("/app/doctors")
      .then(res => {
        let data = res.data.items.filter(item => !item.test)
        setRegisteredDoctors(data)
        setFilteredData(data)
        setErrorMsg("");
        setLoading(false);
      })
      .catch((err) => {
        setErrorMsg(err);
        setLoading(false);
      })

    serverInstance.get("/app/alumni")
      .then(res => {
        // reduce items if first_name last_name and occupation and graduated_year are same
        const reducedItems = res.data.items.reduce((acc, item) => {
          const existingItem = acc.find(i => i.first_name === item.first_name && i.last_name === item.last_name && i.occupation === item.occupation && i.graduated_year === item.graduated_year);
          if (!existingItem) {
            return [...acc, item];
          }
          return acc;
        }, []);
        setAlumniData(reducedItems)
      })
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    const filtered = registeredDoctors.filter((item) => {
      item.designated = (term === item.first_name.toLowerCase())
      return (
        (item.first_name.toLowerCase().includes(term)) ||
        (item.last_name.toLowerCase().includes(term)) ||
        (item.workplace && item.workplace.toLowerCase().includes(term)) ||
        (item.occupation && item.occupation.toLowerCase().includes(term)) ||
        (item.job && item.job.toLowerCase().includes(term))
      );
    });
    setFilteredData(filtered);

    if (term) {
      const filteredAlumni = alumniData.filter((item) => {
        return (
          (item.first_name.toLowerCase() === term)
          // (item.first_name.toLowerCase().includes(term))
        );
      });
      setMatchingAlumniData(filteredAlumni);
    }
    else {
      setMatchingAlumniData([]);
    }
  };

  return (
    <div className='items-container' id='doctors'>

      {loading ? <Dimmer /> : null}

      <section className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>

          <div className="input-container">
            <input
              type='text'
              placeholder={data.placeholder}
              value={searchTerm}
              onChange={handleSearch}
              className=''
            />
            <button className="search-btn">
              <IoSearchOutline size={18} />
            </button>
          </div>
        </div>
      </section>

      <section className='main-container'>
        {errorMsg ? <div className="error-msg">
          <IoWarning />
          &nbsp;
          {errorMsg}
        </div> : null}

        {loading ? null
          :
          filteredData?.length === 0 && matchingAlumniData?.length === 0?
            <div className="no-data">{data.noData}</div>
            :
            <div className="search-result">
              <div className="count">Хайлтын үр дүн: {filteredData.length}</div>

              <div className="items">
                {filteredData.map((item, index) => (
                  <div key={"doctors" + index} className='doctor-item'>
                    <div className='img-container'>
                      <div className={'rounded-circle d-flex justify-content-center align-items-center' + (item.paid === true ? ' paid' : item.fileUrl ? ' bordered' : '')}
                        style={{ objectFit: "cover", width: 120, height: 120 }}
                        >
                        <img src={item.fileUrl ? `https://msid-asset.s3.ap-northeast-2.amazonaws.com/${item.fileUrl}` : "/images/team/member.png"}/>
                      </div>
                      {item.designated ?
                        <div className="verified">
                          <LuBadgeCheck size={20} color="#22b861" />
                          <span>{data.verified}</span>
                        </div>
                        : null}
                    </div>
                    <div className='personal-info'>
                      <div className='name'>
                        {item.last_name.slice(0, 1)}.{item.first_name}
                      </div>
                      <div className='job'>{item.job || item.occupation}</div>
                      <div className='workplace'>{item.workplace}</div>
                    </div>
                  </div>
                ))}

                {matchingAlumniData.map((item, index) => (
                  <div key={"alumni" + index} className='doctor-item'>
                    <div className='img-container'>
                      <div className='rounded-circle d-flex justify-content-center align-items-center'
                        style={{ objectFit: "cover", width: 120, height: 120 }}
                        >
                        <img src={"/images/team/member.png"}/>
                      </div>
                      <div className="alumni">
                        <span>{data.alumni}</span>
                      </div>
                    </div>
                    <div className='personal-info'>
                      <div className='name'>
                        {item.last_name.slice(0, 1)}.{item.first_name}
                      </div>
                      <div className='job'>{item.job || item.occupation}</div>
                      <div className='workplace'>{item.workplace}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
        }
      </section>
    </div>
  );
};

export default Doctors;
